import React, { use, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useForm, Controller } from 'react-hook-form';
import { Modal, Button, Card } from 'react-bootstrap';
import SweetAlert2 from 'react-sweetalert2';
import { Tooltip } from 'react-tooltip';
import apiService from '../../../Auth/apiService';
import CargandoSpinner from "../../Utils/CargandoSpinner";
import SeccionPageHeader from "../../Utils/SeccionPageHeader";
import { useAuth } from '../../../Auth/AuthContext';
import { ConvertErrors422ToString } from '../../Utils/ConvertErrors422ToString';
import { generarPdfAyuda } from './GenerarPdfAyuda';
import 'react-datepicker/dist/react-datepicker.css';
import DatePicker, { registerLocale, setDefaultLocale } from 'react-datepicker';
import { es, th } from 'date-fns/locale';
import { FaCalendar } from "react-icons/fa";

registerLocale('es', es);
setDefaultLocale('es');
// CustomInput moved outside of Persona for best practices and prop validation
const CustomInput = React.forwardRef(({ value, onClick }, ref) => (
    <button
        type="button"
        className="custom-input"
        onClick={onClick}
        ref={ref}
        aria-label="Seleccionar fecha"
        style={{ display: 'flex', alignItems: 'center', border: 'none', background: 'none', padding: 0 }}
    >
        <input value={value} readOnly className='widthCalendar' tabIndex={-1} style={{ pointerEvents: 'none', background: 'transparent', border: 'none' }} />
        <FaCalendar />
    </button>
));

export default function FormularioDescargarActas() {
    const { token } = useAuth();
    const navigate = useNavigate();
    const [cargando, setCargando] = useState(false);
    const today = new Date().toISOString().split('T')[0];
    const [actas, setActas] = useState([]);
    const [actasSinGenerar, setActasSinGenerar] = useState([]);
    const [filters, setFilters] = useState({
        id: '',
        fecha: '',
        beneficiario: '',
        tipoayu: '',
        entrega: '',
        carpeta: '' ,
        firma: '' ,
        usuario: ''
    });
    const [seleccionarTodo, setSeleccionarTodo] = useState(false);
    const [swalProps, setSwalProps] = useState({})
    const [mostrarPdf, setMostrarPdf] = useState(false);
    const [pdfFile, setPdfFile] = useState(null);
    const { control, handleSubmit, register, setValue, watch, getValues, reset, formState: { errors }} = useForm();
    const pdfContainerStyle = { width: '100%', height: '70vh', border: '1px solid #ccc' };
    const iframeStyle = { width: '100%', height: '100%', border: 'none' };
    const linkStyle = { color: '#007bff', textDecoration: 'underline' };

    const Mensaje = (title, text, icon) => {
        setSwalProps({
            show: true,
            title,
            text,
            icon, // 'success' or 'error'
        });
    };

    function handleSeleccionarTodo(e) {
        const isChecked = e.target.checked;
        setSeleccionarTodo(isChecked);
        const checkboxes = document.querySelectorAll('input[type="checkbox"]');
        checkboxes.forEach(checkbox => {
            checkbox.checked = isChecked;
        });
    }
    
    async function consultarActasPorFecha(data) {
        setCargando(true);
        try {
            const response = await apiService.post('/bodega/consultaractasporfecha', data, token);
            if (response.status === 200) {
                setActas(response.data.resultados);
            }
        } catch (error) {
            if(error.status === 422){
                Mensaje('Guardar usuario', ConvertErrors422ToString(error.response.data.errors));
            }else if(error.status === 409){
                Mensaje('Guardar usuario', JSON.stringify(error.response.data));
            }
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
        }
    }
    
    async function descargarActasSeleccionadas() {
        const checkboxes = Array.from(document.querySelectorAll('tbody input[type="checkbox"]'));
        const seleccionadas = checkboxes
            .map((cb, idx) => cb.checked ? actas[idx] : null)
            .filter(Boolean);
        if (seleccionadas.length === 0) {
            Mensaje('Descargar actas', 'Seleccione al menos una acta para descargar.', 'error');
            return;
        }
        setCargando(true);
        let responses = [];
        for (const acta of seleccionadas) {
            const response = await consultarActaSeleccionada(acta);
            responses.push(response);
            let okCount = responses.filter(r => !(r instanceof Error)).length;
            let badCount = responses.filter(r => r instanceof Error).length;
            Mensaje('Resumen de descargas', `Descargas exitosas: ${okCount}\nDescargas fallidas: ${badCount}`, badCount === 0 ? 'success' : 'error');
        }
        setCargando(false);
    }

    async function consultarActaSeleccionada( acta ) {

        try {
            const response = await apiService.getFile('/archivo/descargaractasdigitales', { id: acta.id }, token);
            if(response.status === 200){
                const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
                const link = document.createElement('a');
                link.href = url;
                link.download = `${acta.ate_idpersona}_${acta.tip_tipoahu}_${acta.ayu_ayuda || ''}_${acta.id}.pdf`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            }
        } catch (error) {
            throw error;
        }

        
    }

    async function MostrarFormularioProcesoFirma(idProcesoFirma) {
        if (!idProcesoFirma) {
            Mensaje('Error', 'No hay un proceso de firma asociado a esta acta.', 'error');
            return;
        }
        navigate(`/bodega/editarprocesofirma/${idProcesoFirma}`);
    }

    useEffect(() => {
        async function fetchData() {
            setCargando(true);
            try {
                const response = await apiService.get('/bodega/consultaractassingenerar', token);
                if (response.status === 200) {
                    setActasSinGenerar(response.data.resultados);
                }
            } catch (error) {
                if(error.status === 422){
                    Mensaje('Actas', ConvertErrors422ToString(error.response.data.errors));
                }else if(error.status === 409){
                    Mensaje('Actas', JSON.stringify(error.response.data));
                }
                console.error('Error fetching data:', error);
            } finally {
                setCargando(false);
            }
        }
        fetchData();
    }, []);
    
    return (
        <div className="content-wrapper">
            <SeccionPageHeader
                title="Actas entregadas"
                idCabezaFamilia="0"
                nombreurl="AHE"
                nombreform="Actas entregadas"
            />
            <CargandoSpinner Cargando={cargando} />
            <section className="content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card card-primary card-outline">
                                <div className="card-header">
                                    <h3 className="card-title">Actas entregadas</h3>
                                </div>
                                <div className="card-body">
                                    {actasSinGenerar.length === 0 ? (
                                        <div className="text-center text-muted">No hay actas para mostrar.</div>
                                    ) : (
                                        <div>
                                            <div className="row mb-2">
                                                <div className="col-md-2">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Fecha (YYYY-MM-DD)"
                                                        value={filters.fecha}
                                                        onChange={e => setFilters(f => ({ ...f, fecha: e.target.value }))}
                                                    />
                                                </div>
                                                <div className="col-md-2">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Id persona"
                                                        value={filters.beneficiario}
                                                        onChange={e => setFilters(f => ({ ...f, beneficiario: e.target.value }))}
                                                    />
                                                </div>
                                                <div className="col-md-2">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Tipo ayuda"
                                                        value={filters.tipoayu}
                                                        onChange={e => setFilters(f => ({ ...f, tipoayu: e.target.value }))}
                                                    />
                                                </div>
                                                <div className="col-md-1">
                                                    <button className="btn btn-secondary" onClick={() => setFilters({
                                                        id: '', fecha: '', beneficiario: '', tipoayu: '', entrega: '', carpeta: '', firma: '', usuario: ''
                                                    })}>Limpiar</button>
                                                </div>
                                            </div>
                                            <div className="table-responsive">
                                                <table className="table table-bordered table-hover">
                                                    <thead>
                                                        <tr>
                                                            <th>#</th>
                                                            <th>Id</th>
                                                            <th>Fecha</th>
                                                            <th>Beneficiario</th>
                                                            <th>Id cabeza</th>
                                                            <th>Tipo de Atenci&oacute;n</th>
                                                            <th>Tipo de Ayuda</th>
                                                            <th>Tipo de Entrega</th>
                                                            <th>En carpeta</th>
                                                            <th>Constancia 1</th>
                                                            <th>Constancia 2</th>
                                                            <th>Cédula A</th>
                                                            <th>Cédula B</th>
                                                            <th>Firma</th>
                                                            <th>Usuario</th>
                                                            <th>Acta</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {actasSinGenerar
                                                            .filter(acta => {
                                                                return (
                                                                    (!filters.fecha || (acta.ate_fecha || '').split('T')[0].includes(filters.fecha)) &&
                                                                    (!filters.beneficiario || (acta.ate_idpersona || '').toString().toLowerCase().includes(filters.beneficiario.toLowerCase())) &&
                                                                    (!filters.tipoayu || (acta.ayuda || '').toString().toLowerCase().includes(filters.tipoayu.toLowerCase()))
                                                                );
                                                            })
                                                            .map((acta, idx) => (
                                                            <tr key={acta.id || idx}>
                                                                <td>{idx + 1}</td>
                                                                <td>{acta.id}</td>
                                                                <td>{acta.ate_fecha.split('T')[0]}</td>
                                                                <td>{acta.ate_idpersona || '-'}</td>
                                                                <td>{acta.ate_idcabezafamilia || '-'}</td>
                                                                <td>{acta.tip_tipoahu || '-'}</td>
                                                                <td>{acta.ayuda || '-'}</td>
                                                                <td>{acta.tip_tipoentrega || '-'}</td>
                                                                <td>{acta.act_idcarpetasimg ? 'SI' : '-'}</td>
                                                                <td>{acta.constanciauno || '-'}</td>
                                                                <td>{acta.constanciados || '-'}</td>
                                                                <td>{acta.cedulaa || '-'}</td>
                                                                <td>{acta.cedulab || '-'}</td>
                                                                <td>{acta.firma || '-'}</td>
                                                                <td>{acta.nombreusuario || '-'}</td>
                                                                <td>
                                                                    {!acta.act_idcarpetasimg && acta.firma === 'SI' && (
                                                                        <div className="btn-group" role="group" aria-label="Acciones acta">
                                                                            <button
                                                                                className="btn btn-sm btn-outline-secondary"
                                                                                onClick={async () => {
                                                                                    setCargando(true);
                                                                                    const pdfUrl = await generarPdfAyuda(acta.id, acta.rol, acta.ate_idcabezafamilia, acta.act_idusuarioentrega, acta.idprocesofirma, token, acta.ayuda);
                                                                                    if (!pdfUrl) {
                                                                                        Mensaje('Error', 'No se pudo generar el PDF.', 'error');
                                                                                    }
                                                                                    if (pdfUrl) {
                                                                                        setPdfFile(pdfUrl);
                                                                                        setActasSinGenerar(prevActas => prevActas.filter(a => a.id !== acta.id));
                                                                                        setMostrarPdf(true);
                                                                                    } else {
                                                                                        Mensaje('Error', 'No se pudo generar el PDF.', 'error');
                                                                                    }
                                                                                    setCargando(false);
                                                                                }}
                                                                                disabled={cargando}
                                                                            >
                                                                                Generar
                                                                            </button>
                                                                            <button
                                                                                className="btn btn-sm btn-outline-warning ml-2"
                                                                                onClick={async () => {
                                                                                    await MostrarFormularioProcesoFirma(acta.idprocesofirma);
                                                                                }}
                                                                                disabled={cargando}
                                                                            >
                                                                                Modificar proceso firma
                                                                            </button>
                                                                        </div>
                                                                    )}
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='row'>
                        <div className="col-md-12">
                            <Card>
                                <Card.Body>
                                    <form onSubmit={handleSubmit(consultarActasPorFecha)} className="mb-4">
                                        <div className="form-row">
                                            <div className="form-group col-md-2">
                                                <label htmlFor="fechainicio">Fecha inicio</label>
                                                <Controller
                                                    control={control}
                                                    name="fechainicio"
                                                    rules={{
                                                        required: 'La fecha de inicio es requerida',
                                                        validate: value => value ? true : 'La fecha de inicio es requerida'
                                                    }}
                                                    render={({ field }) => (
                                                        <div style={{ border: '1px solid #ced4da', borderRadius: 4, padding: 2, display: 'inline-block' }}>
                                                            <DatePicker
                                                                placeholderText="Fecha inicio"
                                                                onChange={date => field.onChange(date)}
                                                                showMonthDropdown
                                                                showYearDropdown
                                                                dropdownMode="select"
                                                                selected={field.value instanceof Date ? field.value : (field.value ? new Date(field.value) : null)}
                                                                customInput={<CustomInput />}
                                                                locale="es"
                                                                dateFormat="yyyy-MM-dd"
                                                                maxDate={new Date()}
                                                            />
                                                        </div>
                                                    )}
                                                />
                                                {errors.fechainicio && <p style={{ color: 'red' }}>{errors.fechainicio.message}</p>}
                                            </div>
                                            <div className="form-group col-md-2">
                                                <label htmlFor="fechafinal">Fecha final</label>
                                                <Controller
                                                    control={control}
                                                    name="fechafinal"
                                                    rules={{
                                                        required: 'La fecha final es requerida',
                                                        validate: (value) => {
                                                            const inicio = new Date(watch('fechainicio'));
                                                            const final = new Date(value);
                                                            // Diferencia en meses (aprox, 31 días)
                                                            const diffTime = final.getTime() - inicio.getTime();
                                                            const diffDays = diffTime / (1000 * 3600 * 24);
                                                            if (diffDays < 0) return "La fecha final debe ser igual o posterior a la inicial";
                                                            if (diffDays > 31) return "El rango máximo permitido es de 1 mes";
                                                            return true;
                                                        }
                                                    }}
                                                    render={({ field }) => (
                                                        <div style={{ border: '1px solid #ced4da', borderRadius: 4, padding: 2, display: 'inline-block' }}>
                                                            <DatePicker
                                                                placeholderText="Fecha final"
                                                                onChange={date => field.onChange(date)}
                                                                showMonthDropdown
                                                                showYearDropdown
                                                                dropdownMode="select"
                                                                selected={field.value instanceof Date ? field.value : (field.value ? new Date(field.value) : null)}
                                                                customInput={<CustomInput />}
                                                                locale="es"
                                                                dateFormat="yyyy-MM-dd"
                                                                maxDate={new Date()}
                                                                minDate={watch('fechainicio') ? new Date(watch('fechainicio')) : undefined}
                                                            />
                                                        </div>
                                                    )}
                                                />
                                                {errors.fechafinal && (
                                                    <p style={{ color: 'red' }}>{errors.fechafinal.message}</p>
                                                )}
                                            </div>
                                        </div>
                                        <button type="submit" className="btn btn-primary mt-2">
                                            Consultar Actas Por Fechas
                                        </button>
                                    </form> 
                                </Card.Body>
                            </Card>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card card-primary card-outline">
                                <div className="card-header">
                                    <h3 className="card-title">Actas entregadas</h3>
                                </div>
                                <div className="card-body">
                                    <button
                                        className="btn btn-success mb-3"
                                        disabled={actas.length === 0}
                                        onClick={async () => { descargarActasSeleccionadas(); setSeleccionarTodo(false); }}
                                    >
                                        Descargar actas seleccionadas
                                    </button>
                                    
                                    {actas.length === 0 ? (
                                        <div className="text-center text-muted">No hay actas para mostrar.</div>
                                    ) : (
                                        <div className="table-responsive">
                                            <table className="table table-bordered table-hover">
                                                <thead>
                                                    <tr>
                                                        <th><input type="checkbox" value={seleccionarTodo} onChange={handleSeleccionarTodo} /></th>
                                                        <th>#</th>
                                                        <th>Id</th>
                                                        <th>Fecha</th>
                                                        <th>Beneficiario</th>
                                                        <th>Tipo de Ayuda</th>
                                                        <th>Tipo de Entrega</th>
                                                        <th>En carpeta</th>
                                                        <th>Constancia 1</th>
                                                        <th>Constancia 2</th>
                                                        <th>Cédula A</th>
                                                        <th>Cédula B</th>
                                                        <th>Firma</th>
                                                        <th>Usuario</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {actas.map((acta, idx) => (
                                                        <tr key={acta.id || idx}>
                                                            <td><input disabled={!acta.act_idcarpetasimg} type="checkbox" value={acta.seleccionar} /></td>
                                                            <td>{idx + 1}</td>
                                                            <td>{acta.id}</td>
                                                            <td>{acta.ate_fecha.split('T')[0]}</td>
                                                            <td>{acta.beneficiario || acta.ate_idpersona || '-'}</td>
                                                            <td>{acta.tip_tipoahu || '-'} {acta.ayu_ayuda || ''}</td>
                                                            <td>{acta.tip_tipoentrega || '-'}</td>
                                                            <td>{acta.act_idcarpetasimg ? 'SI' : '-'}</td>
                                                            <td>{acta.constanciauno || '-'}</td>
                                                            <td>{acta.constanciados || '-'}</td>
                                                            <td>{acta.cedulaa || '-'}</td>
                                                            <td>{acta.cedulab || '-'}</td>
                                                            <td>{acta.firma || '-'}</td>
                                                            <td>{acta.nombreusuario || '-'}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                    <Modal show={mostrarPdf} onHide={() => setMostrarPdf(false)} size="xl" centered>
                        <Modal.Header closeButton>
                            <Modal.Title>Vista previa del Acta</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            {pdfFile && (
                                <>
                                    <div style={pdfContainerStyle}>
                                        <iframe
                                            src={pdfFile}
                                            style={iframeStyle}
                                            title="PDF acta"
                                            allow="autoplay; encrypted-media"
                                            loading="lazy"
                                        />
                                    </div>
                                    <div style={{ textAlign: 'center', marginTop: 10 }}>
                                        <a
                                            href={pdfFile}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            style={linkStyle}
                                        >
                                            Abrir PDF en otra pestaña
                                        </a>
                                    </div>
                                </>
                            )}
                        </Modal.Body>
                    </Modal>
                </div>
                <SweetAlert2
                    {...swalProps}
                    didClose={() => setSwalProps({})}
                    onConfirm={() => {
                        if (swalProps.icon === 'success') {
                            setSwalProps({});
                            irAResultado();
                        } else {
                            setSwalProps({});
                        }
                    }}
                />
                <Tooltip id="tooltiparriba" place="right"/>  
            </section>
        </div>
    );

}